export default {
  title: "RC карталарын жайылтуу",
  unavailablePage: "Баракча жеткиликсиз",
  entityOnModeration: "Сиздин юридикалык жак модерация стадиясында",
  buyTariffToGetAccess: "Бул баракчага кирүү үчүн тариф сатып алуу керек",
  createShopToGetAccess:
    "Баракчага жана жаңы колдонуучуларды чакыруу үчүн QR-кодго жетүү алуу үчүн соода түйүнүн түзүңүз",

  inviteClients: "Кардарларды чакыруу",

  branding: {
    title: "Промо-материалдарды бренддештирүү",
    descriptions: [
      "RC GROUPтун бренддештирилген промо-материалдары менен көбүрөөк кардарларды тартууга аракет кылыңыз! Туруктуу кардарлар кайра кайтып келип, жаңылары көбөйүшү үчүн бардык мүмкүнчүлүктөрдү колдонуңуз!",
      "Жаркын стикерлер жана кооз тейбл-тенттер менен компанияңызга кызыгуу жараттырыңыз! Алардын үстүндө — кардарлык кызмат тууралуу маалымат, катталуу үчүн QR-коддор жана RC PAY аркылуу сатып алуулардагы пайдалуу сунуштар!",
      "Сиз кардарлардын берилгендик программасына катышуучу экениңизди көрсөтүңүз жана башкалардын арасынан айырмаланыңыз! Жаңы кардарларды арзандатуулар жана пайдалуу акциялар менен тартууңуз!",
    ],
    promoLink: "Промо-материалдарга шилтеме",
    downloadInstruction: "Нускама жүктөп алуу",
  },

  mainInfo: "Негизги маалымат",

  faq: [
    {
      title: "Жайгаштыруу",
      text: "Биз тейбл-тентти QR-код жана «Бонус картасын жүктө! Бонус баллдарды топто жана сатып алууда өзгөчө шарттарга ээ бол» деген жазуу менен кассанын жанына же сатып алуучулар төлөм жасаган жерге жайгаштырууну сунуштайбыз. Мисалы, кафе үстөлдөрүндө, дүкөндүн кассасы жанындагы күтүү зонасында же башка көрүнүктүү жерде.",
    },
    {
      title: "RC KASSA аркылуу картаны алуу",
      text: "RC KASSA тиркемесин колдонуп, өз QR-кодуңузду көрсөтүңүз: жогору оң бурчтагы үч чекитти басып, «QR-кодду ачуу» тандаңыз. Кардарга телефондун камерасы менен сканерлөөнү сунуштаңыз.",
    },
    {
      title: "Кызматкерлер менен иштөө",
      text: "Дүйнөлүк тажрыйба көрсөткөндөй, кызматкерлер берилгендик программаларын кээде кабыл албай коюшат. Бул эски пластикалык гана эмес, RC Group сыяктуу санариптик чечимдерге да тиешелүү. Кээ бир кызматкерлер кардарларга программа тууралуу айтып берүү уюмдун кирешесин азайтат деп ойлошу мүмкүн. Бул жаңылыш пикир. Программанын жайылышы канчалык кең болсо, орточо сатып алуу суммасы, сатып алуу жыштыгы жана брендге берилгендик ошончолук жогору болот. Мындан тышкары, бул СМС жана башка билдирүүлөрдүн чыгымдарын азайтып, кардарларды жакшыраак таанууга мүмкүндүк берет.",
    },
  ],
};
